import { SysOption } from 'bff/models/info';

export const SYSTEM_FETCH_URL_SYS_OPTS = 'SYSTEM_FETCH_URL_SYS_OPTS';
export const SYSTEM_SAVE_URL_SYS_OPTS = 'SYSTEM_SAVE_URL_SYS_OPTS';

export interface FetchUrlSysOptsAction {
  type: typeof SYSTEM_FETCH_URL_SYS_OPTS;
  payload: {
    onComplete?: () => Promise<void>; // 宣告為非同步函式
  }
};

export interface SaveUrlSysOptsAction {
  type: typeof SYSTEM_SAVE_URL_SYS_OPTS;
  payload: {
    data: SysOption[];
  };
};

export type SystemActions =
  FetchUrlSysOptsAction |
  SaveUrlSysOptsAction;
